import { Stack } from '@mui/joy';
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { theme } from '@/setup/theme';

function RouteComponent() {
  return (
    <Stack
      alignItems="center"
      sx={{
        backgroundColor: theme.palette.background.surface,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Outlet />
    </Stack>
  );
}

export const Route = createFileRoute('/_authenticated/anordnung')({
  component: RouteComponent,
});
